import React from "react";
import * as styles from "./WordButton.module.css";
import { Toggle } from "../ui/toggle";
import { trackWordSelected } from "../../lib/analytics";

import { GameStatusContext } from "../../providers/GameStatusProvider";

function WordButton({ word, fullCandidateSize, isAnimating = false, isMerging = false }) {
  const { guessCandidate, setGuessCandidate } =
    React.useContext(GameStatusContext);
  const [isSelected, setIsSelected] = React.useState(
    !!guessCandidate.includes(word)
  );

  const isCandidateListFull = guessCandidate.length == fullCandidateSize;

  React.useEffect(() => {
    setIsSelected(!!guessCandidate.includes(word));
  }, [guessCandidate]);

  function flipSelection() {
    if (isSelected) {
      trackWordSelected(word, false);
      // remove from candidateGuess
      const updatedGuessCandidate = guessCandidate.filter((w) => {
        return w !== word;
      });
      setGuessCandidate(updatedGuessCandidate);
      // set state to *not* selected
      setIsSelected(false);
    } else {
      // check if the candidate array is full
      if (!isCandidateListFull) {
        trackWordSelected(word, true);
        // add to candidateGuess array
        setGuessCandidate([...guessCandidate, word]);
        // set state to *selected*
        setIsSelected(true);
      }
    }
  }

  return (
    <Toggle
      className={`${styles.growShrink} ${isMerging ? styles.merging : ''} select-none w-full h-full`}
      variant="outline"
      pressed={isSelected}
      onClick={flipSelection}
      disabled={isAnimating || isMerging}
    >
      <span className="uppercase tracking-[0.05em] md:tracking-[0.15em] text-center block text-xs md:text-base px-1">
        {word}
      </span>
    </Toggle>
  );
}

export default WordButton;
